import React, { useEffect, Suspense, lazy, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
// Lazy-load everything below the fold. The first paint only needs the Hero;
// the rest streams in as the user scrolls.
const PainPointsSection = lazy(() => import('./components/PainPointsSection').then(m => ({
  default: m.PainPointsSection
})));
const ProductShowcase = lazy(() => import('./components/ProductShowcase').then(m => ({
  default: m.ProductShowcase
})));
const VolumesDetail = lazy(() => import('./components/VolumesDetail').then(m => ({
  default: m.VolumesDetail
})));
const BonusesSection = lazy(() => import('./components/BonusesSection').then(m => ({
  default: m.BonusesSection
})));
const CountdownSection = lazy(() => import('./components/CountdownSection').then(m => ({
  default: m.CountdownSection
})));
const PricingSection = lazy(() => import('./components/PricingSection').then(m => ({
  default: m.PricingSection
})));
const TestimonialsSection = lazy(() => import('./components/TestimonialsSection').then(m => ({
  default: m.TestimonialsSection
})));
const GuaranteeSection = lazy(() => import('./components/GuaranteeSection').then(m => ({
  default: m.GuaranteeSection
})));
const FAQSection = lazy(() => import('./components/FAQSection').then(m => ({
  default: m.FAQSection
})));
const FinalCTASection = lazy(() => import('./components/FinalCTASection').then(m => ({
  default: m.FinalCTASection
})));
const FooterSection = lazy(() => import('./components/FooterSection').then(m => ({
  default: m.FooterSection
})));
const PurchaseNotification = lazy(() => import('./components/PurchaseNotification').then(m => ({
  default: m.PurchaseNotification
})));
// Run network hints synchronously, before React even mounts, so the browser
// can open the TCP/TLS sockets to our image CDN while the JS is still parsing.
if (typeof document !== 'undefined' && !(window as any).__mpNetHints) {
  ;
  (window as any).__mpNetHints = true;
  const head = document.head;
  const addHint = (rel: string, href: string, crossOrigin?: string) => {
    const link = document.createElement('link');
    link.rel = rel;
    link.href = href;
    if (crossOrigin) link.crossOrigin = crossOrigin;
    head.appendChild(link);
  };
  addHint('preconnect', 'https://cdn.magicpatterns.com', 'anonymous');
  addHint('dns-prefetch', 'https://cdn.magicpatterns.com');
  addHint('dns-prefetch', 'https://connect.facebook.net');
  const preload = document.createElement('link');
  preload.rel = 'preload';
  preload.as = 'image';
  preload.href = 'https://cdn.magicpatterns.com/uploads/xreJrC7QZ2pqEundwF9PmH/Sin-titulo-_420-x-420-px_.webp';
  (preload as any).fetchPriority = 'high';
  head.appendChild(preload);
}
export function App() {
  useEffect(() => {
    if ('requestIdleCallback' in window) {
      ;
      (window as any).requestIdleCallback(() => loadPixel(), {
        timeout: 12000
      });
    } else {
      setTimeout(loadPixel, 10000);
    }
  }, []);
  return <main className="font-body text-white bg-brand-dark overflow-x-hidden" data-id="element-0">
      <HeroSection data-id="element-1" />
      <Suspense fallback={null} data-id="element-2">
        <PainPointsSection data-id="element-3" />
        <ProductShowcase data-id="element-4" />
        <VolumesDetail data-id="element-5" />
        <BonusesSection data-id="element-6" />
        <CountdownSection data-id="element-7" />
        <PricingSection data-id="element-8" />
        <TestimonialsSection data-id="element-9" />
        <GuaranteeSection data-id="element-10" />
        <FAQSection data-id="element-11" />
        <FinalCTASection data-id="element-12" />
        <FooterSection data-id="element-13" />
        <PurchaseNotification data-id="element-14" />
      </Suspense>
    </main>;
}
function loadPixel() {
  if (typeof window !== 'undefined' && !(window as any).fbq) {
    const f = window as any;
    const n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [] as any[];
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    (window as any).fbq('init', '1170774765082882');
    (window as any).fbq('track', 'PageView');
  }
}